import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {AdministrationResultStatus, ServiceCategoryData} from 'src/app/clients/system-api/SystemApiClient';
import {ServiceEnum} from 'src/app/enums/service.enum';
import {DataGridColumnType, DataGridSettingModel, SelectionListModel} from 'src/app/models/data-grid.model';
import {ServiceCategoryService} from 'src/app/services/service-category.service';
import {ServiceService} from 'src/app/services/service.service';
import {SnackBarService} from 'src/app/services/snack-bar.service';
import {MatDialog} from "@angular/material/dialog";
import {ServiceCategoryPopupComponent} from "../../components/pop-ups/service-category-popup/service-category-popup.component";
import { GenericModalComponent } from 'src/app/components/modals/generic-modal/generic-modal.component';

@Component({
  selector: 'app-service-page',
  templateUrl: './service-page.component.html',
  styleUrls: ['./service-page.component.scss']
})
export class ServicePageComponent implements OnInit {
  @ViewChild(GenericModalComponent) genericModalComponent!: GenericModalComponent;

  length = 100;
  dataGridSettings!: DataGridSettingModel;
  selectionList: SelectionListModel[] = []

  serviceCategoryData: ServiceCategoryData[] = []
  windowWidth: any
  serviceCategoryId!: number;

  addServiceCategoryPopupState: boolean = false;
  editServiceCategoryPopupState: boolean = false;

  constructor(private serviceService: ServiceService,
              private serviceCategoryService: ServiceCategoryService,
              public translate: TranslateService,
              private _snackBarService: SnackBarService,
              private dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.InitiateGrid();
    this.windowWidth = window.innerWidth;

    this.retrieveAllServiceCategory();
  }

  retrieveAllServiceCategory(){
    this.serviceCategoryService.retrieveAllServiceCategories().subscribe((data) => {
      if(data.status == AdministrationResultStatus.Success){
        this.serviceCategoryData = data.content?.items!;

        for (let i = 0; i < data.content!.items!.length; i++) {
          this.selectionList.push({"id": data.content!.items![i].id!, "name": data.content!.items![i].name!})
        }
      } else {
        this._snackBarService.callSnackBar("Error", "error");
      }
    });
  }

  InitiateGrid() {
    this.dataGridSettings = {
      dataService: this.serviceService,
      getAllServiceName: 'retrieveAllServices',
      columns: [
        {
          DbName: ServiceEnum.name,
          Name: 'name',
          LocalizationKey: 'WWW.Name',
          Type: DataGridColumnType.String
        },
        {
          DbName: ServiceEnum.price,
          Name: 'price',
          LocalizationKey: 'WWW.Name',
          Type: DataGridColumnType.Number,
        },
        {
          DbName: ServiceEnum.serviceCategoryName,
          Name: 'category',
          LocalizationKey: 'WWW.Name',
          Type: DataGridColumnType.String,
        },
        {
          DbName: ServiceEnum.duration,
          Name: 'duration',
          LocalizationKey: 'WWW.Name',
          Type: DataGridColumnType.Number,
        },
        {
          DbName: ServiceEnum.active,
          Name: 'status',
          LocalizationKey: 'WWW.Name',
          Type: DataGridColumnType.Bool,
          Width: '12rem',
        },
        {
          DbName: 'CUSTOM_2',
          Name: 'change',
          LocalizationKey: 'WWW.Edit',
          Type: DataGridColumnType.Edit,
          Width: '100px',
          TextAlign: 'center'
        }
      ],
      sorting: true,
      isDataPaged: true,
      defaultPageSize: '5',
      sortBy: '',
      enableSearch: true,
      enableRefresh: true,
      searchTitle: 'Search services',
      searchColumns: ['SearchParam', 'SelectionId'],
      dataGridName: 'Service',
      searchColumnName: 'Search according to name of service',
      selectionName: 'Search according to category',
      editUrl: '/dashboard/service/edit',
      addUrl: '/dashboard/service/add',
      editComponent: 'ServiceEditComponent',
      addComponent: 'ServiceAddComponent',
      selectionList: this.selectionList,
      addButtonName: "add-service"
    }
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.windowWidth = window.innerWidth;
  }

  openEditPopUp(serviceCategoryId: number) {
    this.dialog.open(ServiceCategoryPopupComponent, {data: {serviceCategoryId: serviceCategoryId}})
  }

  openAddCategoryPopUp() {
    let width = this.windowWidth < 640 ? '95%' : 'max-content'
    this.dialog.open(ServiceCategoryPopupComponent, {width: width});
  }

  //Popups
  public toggleAddServicePopup(state?: boolean) {
    this.addServiceCategoryPopupState = false;
    this.addServiceCategoryPopupState = state ?? !this.addServiceCategoryPopupState;
  }

  public toggleEditServicePopup(state?: boolean, serviceCategoryId?: number) {
    this.editServiceCategoryPopupState = false;
    this.serviceCategoryId = serviceCategoryId!;
    this.editServiceCategoryPopupState = state ?? !this.editServiceCategoryPopupState;
  }

  closePopup() {
    this.genericModalComponent.handleClose(true);
    this.addServiceCategoryPopupState = false;
    this.editServiceCategoryPopupState = false;
    this.retrieveAllServiceCategory();
  }
}
